import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

interface GlobalTextAreaProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  rows?: number;
  autoResize?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
}

export const GlobalTextArea: React.FC<GlobalTextAreaProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  rows = 4,
  autoResize = true,
  fullWidth = true,
  maxLength,
}) => {
  return (
    <div style={{ width: fullWidth ? '100%' : 'auto' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '0.85rem',
          fontWeight: 600,
          color: error ? '#dc3545' : '#0f3d3e',
          marginBottom: '6px',
          letterSpacing: '0.2px'
        }}>
          {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
        </label>
      )}
      
      <InputTextarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        autoResize={autoResize}
        maxLength={maxLength}
        style={{
          width: '100%',
          padding: '12px 14px',
          border: `1px solid ${error ? '#dc3545' : '#e5e7eb'}`,
          borderRadius: '10px',
          fontSize: '0.9rem',
          fontWeight: 500,
          transition: 'all 0.2s ease',
          background: disabled ? '#f8f9fa' : 'white',
          color: disabled ? '#999' : '#333',
          minHeight: rows ? `${rows * 24 + 24}px` : '120px',
          resize: autoResize ? 'none' : 'vertical',
          fontFamily: 'inherit',
          lineHeight: '1.5'
        }}
        className="global-textarea"
      />
      
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '6px'
      }}>
        {error && (
          <span style={{
            fontSize: '0.75rem',
            color: '#dc3545',
            fontWeight: 500
          }}>
            {error}
          </span>
        )}
        
        {maxLength && (
          <span style={{
            fontSize: '0.75rem',
            color: value.length >= maxLength ? '#dc3545' : '#999',
            fontWeight: 500,
            marginLeft: 'auto'
          }}>
            {value.length}/{maxLength}
          </span>
        )}
      </div>

      <style>{`
        .global-textarea::placeholder {
          color: #999;
          opacity: 0.7;
        }

        .global-textarea:enabled:focus {
          outline: 0;
          border-color: #0f3d3e !important;
          box-shadow: 0 0 0 3px rgba(15, 61, 62, 0.1) !important;
        }

        .global-textarea:enabled:hover {
          border-color: #1a5555 !important;
        }

        .global-textarea:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .global-textarea::-webkit-scrollbar {
          width: 8px;
        }

        .global-textarea::-webkit-scrollbar-track {
          background: #f8f9fa;
          border-radius: 4px;
        }

        .global-textarea::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 4px;
        }

        .global-textarea::-webkit-scrollbar-thumb:hover {
          background: #0f3d3e;
        }
      `}</style>
    </div>
  );
};